import { createContext } from 'react';

import type { IAppContext } from '@/Module/Core/Model/DataModel';
import { DeviceType } from '@/Module/Core/Model/Enum';

const AppContext = createContext({
  deviceType: DeviceType.DESKTOP,
} as IAppContext);

export default AppContext;
